import { Grid } from '@material-ui/core';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { styles } from 'src/common/components/interactive-dialogue/components/interactive-dialogue/interactive-dialogue-styles';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { useTranslation, InterpolationArguments } from 'react-i18next';

export interface INotificationProps {
  onApprove: () => void;
  message?: string;
  subMessage?: string;
  subMessageArgs?: InterpolationArguments;
  dialogWidth?: number;
  dialogHeight?: number;
  type?: EmeraldDialogTypes;
  dialogTestIdPrefix?: string;
}

export const showNotificationDialog = (props: INotificationProps): void => {
  const modalConfig: IMessageModal = {
    type: props.type || EmeraldDialogTypes.Info,
    message: props.message,
    subMessage: props.subMessage,
    subMessageArgs: props.subMessageArgs,
    dialogTestIdPrefix: props.dialogTestIdPrefix,
    disableBackdropClick: true,
    hideCancelButton: true,
    buttonComponent: <AcceptButton onApprove={props.onApprove} />,
  };
  showEmeraldDialog(modalConfig);
};

export const AcceptButton = (props: INotificationProps): JSX.Element => {
  const classes = styles({
    maxWidth: props.dialogWidth ?? 43.99,
    height: props.dialogHeight ?? 65.1,
    fullScreen: false,
  });
  const { t } = useTranslation();
  return (
    <Grid container className={classes.dialogContent}>
      <Grid>
        <BaseButton
          className={classes.acceptButton}
          data-testid={'dialog-messages-accept'}
          onClick={props.onApprove}
        >
          <span className='label'>{t('Ok')}</span>
        </BaseButton>
      </Grid>
    </Grid>
  );
};
